// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"201":"276ac4fd","372":"878aa0e3","466":"085330d8","541":"2814f74a","787":"9a0c5618","815":"6d9b8880","849":"d07abbfd","856":"e8c0defa"}[chunkId] + ".chunk.js";
};